<template>
  <!-- 技术参数 -->
  <div style="height: 100%">
    <!-- 单个机型数据 -->
    <el-table
      v-if="!isCompare"
      :data="turbineTableData"
      v-loading="turbineTableLoading"
      style="width: 100%"
      :max-height="tableHeight"
      row-class-name="table-row-class-name"
      :header-cell-style="headerCellStyle"
      key="55"
    >
      <el-table-column  width="300" min-width="24%" type="index" align="center" label="序号"> </el-table-column>
      <el-table-column prop="quota" width="auto"  min-width="24%" align="center" label="指标"> </el-table-column>
     
      <el-table-column prop="value"  width="auto" min-width="24%" align="center" label="值">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value" v-if="isSave"> </el-input>
          <span v-else>{{ scope.row.value }}</span>
        </template>
      </el-table-column>
      <el-table-column  width="auto" min-width="24%"prop="unit" align="center" label="单位"> </el-table-column>
    </el-table>
    <!-- 单个机型数据 -->
    <!-- 对比机型数据 -->
    <el-table
      v-else
      v-loading="turbineComparetableloading"
      style="width: 100%"
      key="66"
      :data="turbineTableDatas"
      :max-height="tableHeight"
      row-class-name="table-row-class-name"
      :header-row-style="{
        background: 'transparent',
      }"
      border
      class="jizutable"
    >
      <el-table-column type="index" width="70" label="序号"> </el-table-column>
      <el-table-column prop="quota" width="200" label="指标"> </el-table-column>
      <el-table-column prop="unit" width="260" label="单位"> </el-table-column>
      <el-table-column
        align="center"
        v-for="(item, index) in turbineCheckedColumns"
        :key="index"
        :label="item.label"
        :prop="item.prop"
      >
      </el-table-column>
    </el-table>
    <!-- 对比机型数据 -->
  </div>
</template>

<script>
import {
  filterTechParameters,
  filterCompareTechParameters,
  saveTechParameters
} from '../helper/utils';
import { getToken } from '@/utils';
import { mapState } from 'vuex';
import isEmpty from 'lodash/isEmpty';
export default {
  data() {
    return {
      tableHeight: 0,
      fullHeight: 0,
      isSave: false,
      activeName: 'second',
      turbineTableData: [], // 机组数据详情
      selectedTurbine: {}, // 当前点击的机型数据
      turbineTableDatas: [], // 获取的对比机型数据
      turbineTableLoading: false, // 单个table的Loading
      turbineComparetableloading: false, // 对比table的loading
      headerCellStyle: {
        fontSize: '14px',
        fontWeight: 'bold',
        textAlign: 'center',
        background: '#f8f8f9'
      },
    };
  },
  computed: {
    ...mapState('model', [
      'isCompare',
      'uploadSuccess',
      'turbineCheckedList',
      'currentTurbine'
    ]),
    turbineCheckedColumns() {
      if (isEmpty(this.turbineCheckedList)) return [];
      const cols = [];
      this.turbineCheckedList.forEach((eco, i) => {
        cols.push({
          label: eco.turbineType,
          prop: `value${i === 0 ? '' : i}`,
          id: eco.turbineTypeId
        });
      });
      return cols;
    }
  },
  created() {
    window.addEventListener('resize', this.getBodyHeight);
  },
  mounted() {
    if (Object.keys(this.currentTurbine).length !== 0) {
      this.selectedTurbine = this.currentTurbine;
      if (!this.isCompare) {
        this.fetchTechParamList();
      } else {
        this.fetchCompareTechParamList();
      }
    }
  },
  watch: {
    fullHeight() {
      if (
        this.turbineTableData.length > 0 ||
        this.turbineTableDatas.length > 0
      ) {
        this.calcBoxHeight();
      }
    },
    // 当前点击的的机型对象==>变换
    currentTurbine(val) {
      if (typeof val === 'object' && Object.keys(val).length <= 0) {
        this.turbineTableData = [];
        this.selectedTurbine = {};
        return;
      }
      this.selectedTurbine = val;
      if (!this.isCompare) {
        this.fetchTechParamList();
      }
    },
    // 选中的机型列表
    turbineCheckedList(val) {
      if (val.length === 0) {
        return;
      }
      if (this.isCompare) {
        this.fetchCompareTechParamList();
      }
    },
    // 点击对比
    isCompare(val) {
      if (val) {
        this.fetchCompareTechParamList();
      } else {
        this.fetchTechParamList();
      }
    }
  },
  methods: {
    handleData() {
      this.isSave = true;
    },
    handleSave() {
      this.isSave = false;
      var parm = saveTechParameters(this.turbineTableData);
      this.$set(parm, 'turbineTypeId', this.selectedTurbine.turbineTypeId);
      this.$set(parm, 'apiKey', getToken());
      this.$fetch('/windfarm/turbineType/updateTurbine', {
        method: 'post',
        data: { ...parm },
        showError: true,
        showLoading: true
      }).then(() => {
        this.fetchTechParamList();
      });
    },
    // 获取单个机型的详情
    async fetchTechParamList() {
      this.turbineTableLoading = true;
      try {
        let result = await this.$fetch('/windfarm/turbineType/getTurbine', {
          params: {
            keyword: this.keyword,
            turbineTypeId: this.selectedTurbine.turbineTypeId
          },
          showError: true
        });
        if (
          result.data.turbine &&
          Object.keys(result.data.turbine).length > 0
        ) {
          this.turbineTableData = filterTechParameters(result.data.turbine);
          this.turbineTableLoading = false;
          this.calcBoxHeight();
        } else {
          this.turbineTableLoading = false;
          // this.tableHeight = 295;
        }
      } catch (e) {
        this.turbineTableLoading = false;
      }
    },
    // 获取对比机型
    async fetchCompareTechParamList() {
      this.turbineComparetableloading = true;
      this.$store.commit('model/COMPARE_BUTTON_LOADING', true);
      let apiKey = 'test';
      let turbineTypeIds = this.turbineCheckedList
        .map(item => {
          return parseInt(item.turbineTypeId);
        })
        .join(',');
      try {
        let result = await this.$fetch('windfarm/turbineType/getTurbines', {
          params: {
            keyword: this.keyword,
            turbineTypeIds,
            apiKey
          },
          showError: true
        });
        if (result.data.turbineList && result.data.turbineList.length > 0) {
          this.turbineTableDatas = filterCompareTechParameters(
            result.data.turbineList,
            this.turbineCheckedList
          );
          this.turbineComparetableloading = false;
          this.$store.commit('model/COMPARE_BUTTON_LOADING', false);
          this.calcBoxHeight();
        } else {
          this.turbineComparetableloading = false;
          this.tableHeight = 295;
        }
      } catch (e) {
        this.$store.commit('model/COMPARE_BUTTON_LOADING', false);
        this.turbineComparetableloading = false;
      }
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 !== 0) {
        return 'custom-table-row-odd';
      } else {
        return 'custom-table-row-even';
      }
    },
    // 表格高度自适应
    calcBoxHeight() {
      let viewPortHeight = document.documentElement.clientHeight;
      let documentTop = document.documentElement.clientTop;
      this.tableHeight = viewPortHeight - 150 - documentTop;
      this.$emit('tableHeight', this.tableHeight + 30);
    },
    getBodyHeight() {
      this.fullHeight = document.documentElement.clientHeight;
    },
    handleClick() {}
  }
};
</script>

<style lang="less" scoped>
 
.edit-database {
 width: 100%;
 display: flex;
 align-items: center;
 margin-bottom: 10px;
}
.title {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin-right: 20px;
  /* padding: 4px 0 16px 0; */
}
/deep/div::-webkit-scrollbar,
p::-webkit-scrollbar,
section::-webkit-scrollbar,
h1::-webkit-scrollbar,
h2::-webkit-scrollbar,
h3::-webkit-scrollbar {
  height: 10px !important;
}
</style>
